import * as ng from 'angular';

import { AlertManagerService } from '../../../../../../services';
import { OrganismOverviewController } from '../../../../../organisms/overview/overview';

export class MoleculePanelOverviewHeaderMultiUnlockActionController implements ng.IController {
    public static $inject: string[] = ['alertManager', '$translate'];

    public OrganismOverview: OrganismOverviewController;
    private serviceName: string;

    constructor(
        private alertManager: AlertManagerService,
        protected $translate: ng.translate.ITranslateService
    ) {}

    public getTemplate = () => require('./multi-unlock-' + this.serviceName + '-action.html?external');

    public abort = () => {
        this.OrganismOverview.overviewModel.activeMassAction = false;
    };

    public unlock = () => {
        this.OrganismOverview.submitMassAction({methode: 'unlockSubmit'})
            .then((result) => {
                if (result) {
                    this.alertManager.success(this.$translate.instant('TR_100119-139c51_TR'));
                    this.abort();
                    this.OrganismOverview.onLoad();
                }
            }, (e) => {
                console.error('error', e);
                this.abort();
            });
    };
}

export class MoleculePanelOverviewHeaderMultiUnlockActionComponent implements ng.IComponentOptions {
    public require = {
        OrganismOverview: '^organismOverview'
    };
    public bindings = {
        serviceName: '<'
    };
    public controller =  MoleculePanelOverviewHeaderMultiUnlockActionController;
    public template = require('./multi-unlock-action.html');
}
